import React from 'react'
import { BackButton as NavigationBackButton, BackButtonProps } from 'components/ui/Button/BackButton'
import { useTranslateDefaultTitle } from '../hooks/useTranslateDefaultTitle'

export const BackButton: React.FC<BackButtonProps> = ({ title, ...props }) => {
  const translatedTitle = useTranslateDefaultTitle(title)

  return <NavigationBackButton title={translatedTitle} {...props} />
}
